import { useMessagesContext } from 'Views/Page/Content/Templates/MessagesPage/MessagesContext';
import { addQueryWithReplace, QueryVal, removeQueryWithReplace } from 'Helpers/Query';
import { useDockedContext } from 'Context/DockedContext';

const useThreadList = () => {
  // Messages Context
  const {
    setThreadsCollection,
    selectedThreadResource,
    selectThread,
    setSearching,
    clearSearching,
    clearComposeDraftMessageResource,
    messageSending,
    clearSelectedThreadResource,
  } = useMessagesContext();

  const { undockItem } = useDockedContext();

  const currentHouseholdId = QueryVal('householdId');

  const handleThreadClick = (thread) => {
    // Patch to prevent switching threads while another message is sending
    if (messageSending) {
      return;
    }

    // If we are clicking the already selected thread do nothing
    if (selectedThreadResource && thread.id() === selectedThreadResource.id()) {
      return;
    }

    selectThread(thread);
  };

  const handleHouseholdSelect = async (res, householdId) => {
    if (!householdId) {
      removeQueryWithReplace('householdId');
    } else {
      addQueryWithReplace({ householdId });
    }

    // If the household doesn't change, don't clear the threadSelfLink
    if (currentHouseholdId !== householdId) {
      clearSelectedThreadResource();
    }

    setThreadsCollection(res);
    clearSearching();
  };

  const beforeHandleHouseholdSelect = (householdId) => {
    if (!householdId) {
      undockItem('MessagesPageCompose', {
        skipSave: true,
      });
    }
    clearComposeDraftMessageResource();
    setSearching();
  };

  return {
    handleThreadClick,
    handleHouseholdSelect,
    beforeHandleHouseholdSelect,
  };
};

export { useThreadList };
